import React from 'react';

import { IcoClockWithPause, IcoClockWithShield, IcoClockWithSquare } from 'icons/indexed-icons/IcoClock';
import { IcoWrench } from 'icons/indexed-icons/IcoWrench';
import { IcoCleaning } from 'icons/indexed-icons/IcoCleaning';

import CheckCircle2 from 'icons/indexed-icons/CheckCircle2';
import Offline from 'icons/indexed-icons/Offline';
import { colors } from './colors';
import NoProduct from 'icons/indexed-icons/NoProduct';
import NotRunning from 'icons/indexed-icons/NotRunning';
import TriangleWarning from 'icons/indexed-icons/TriangleWarning';

import { default as DisconnectedIcon } from '../../../../../components/MachineStatus/icons/status_disconnected.svg';
import { default as ConnectedIcon } from '../../../../../components/MachineStatus/icons/status_connected.svg';


export const Icons: Record<string, JSX.Element | string> = {
  idle: <IcoClockWithPause />,
  maintenance: <IcoWrench />,
  cleaning: <IcoCleaning />,
  sterilzation: <IcoClockWithShield />,
  'wait time': <IcoClockWithSquare />,
  'no product': <NoProduct color={colors?.['no product']}/>,
  'not running': <NotRunning color={colors?.['not running']}/>,
  running: <CheckCircle2 color={colors?.['running']} />,
  offline: <Offline color={colors?.['offline']} />,
 'online': <CheckCircle2 color={colors?.['online']}/>,
 'connected': <img className='machine_status' src={ConnectedIcon} />,
 'disconnected': <img className='machine_status' src={DisconnectedIcon} />,
 'unknown': <TriangleWarning color={colors?.['unknown']}/>
};
